import { Shadow, Text, VStack, HStack } from '@genial/components';
import { BoxBorder, Spacing, Typography } from '@genial/design-tokens';
import { FlatList, Pressable } from 'native-base';
import React from 'react';

import { ProductFieldProps } from '../../../../constants';

export interface AssetWithDocument {
  clientDocument: string;
  [key: string]: any;
}

export interface AssetPrincipalCardProps<T extends AssetWithDocument> {
  item: T;
  infos: ProductFieldProps<T>[];
  onSelectClient: (cpfCnpj: string) => void;
}

export const AssetPrincipalCard = <T extends AssetWithDocument>({
  infos,
  item,
  onSelectClient,
}: AssetPrincipalCardProps<T>) => {
  return (
    <Shadow level={1} borderRadius={BoxBorder.heavy} p={Spacing['inset.sm']}>
      <VStack space={Spacing['stack.xxxs']}>
        <HStack justifyContent="space-between" space={Spacing['inline.quarck']}>
          <FlatList
            key="mobile-asset-principal-card-flat-list"
            style={{ overflow: 'visible' }}
            keyExtractor={(info) => info.key as string}
            data={infos}
            renderItem={({ item: info }) => (
              <HStack justifyContent="space-between" py={Spacing['stack.nano']} alignItems="center">
                <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
                  {info.label}
                </Text>
                {info.key === 'clientName' ? (
                  <Pressable onPress={() => onSelectClient?.(item.clientDocument)}>
                    <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
                      {`${item[info.key]}`}
                    </Text>
                  </Pressable>
                ) : (
                  <Text
                    fontSize={Typography['fontsize.md']}
                    color="neutral.black"
                    variant="semibold">
                    {`${item[info.key]}`}
                  </Text>
                )}
              </HStack>
            )}
          />
        </HStack>
      </VStack>
    </Shadow>
  );
};
